/**
 * Where a keyboard shortcut must stand aside.
 *
 * The studio's single-key shortcuts (M = mic, V = camera, Enter = take the
 * scene) listened on the window and skipped only <input> and <textarea>, so
 * typing in a device dropdown toggled the host's mic or camera, and Enter on a
 * focused button ran the scene transition instead of pressing the button.
 */

const ACTIVATABLE_ROLES = new Set([
  'button', 'link', 'menuitem', 'menuitemcheckbox', 'menuitemradio',
  'option', 'tab', 'checkbox', 'radio', 'switch', 'combobox', 'listbox',
]);

/** True when keys typed here belong to the field (text, select, editable). */
export function isTypingTarget(target) {
  if (!target || typeof target !== 'object') return false;
  const tag = String(target.tagName || '').toUpperCase();
  if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true;
  if (target.isContentEditable) return true;
  const role = typeof target.getAttribute === 'function' ? target.getAttribute('role') : null;
  return role === 'textbox' || role === 'combobox' || role === 'listbox';
}

/** True when Enter / Space on this element already does something. */
export function isActivatableTarget(target) {
  if (!target || typeof target !== 'object') return false;
  if (isTypingTarget(target)) return true;
  const tag = String(target.tagName || '').toUpperCase();
  if (tag === 'BUTTON' || tag === 'SUMMARY') return true;
  if (tag === 'A' && typeof target.hasAttribute === 'function' && target.hasAttribute('href')) return true;
  const role = typeof target.getAttribute === 'function' ? target.getAttribute('role') : null;
  return !!role && ACTIVATABLE_ROLES.has(role);
}
